import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PortalDetectionListener from "../portals/PortalDetectionListener";
import { loadTenantSettings } from "../../utils/tenantSettings";
import { QuickPanelProvider } from "../quickpanel/QuickPanelProvider";
import QuickPanelFab from "../quickpanel/QuickPanelFab";
import QuickPanelModals from "../quickpanel/QuickPanelModals";

export default function DashboardLayout({ children, navItems, adminMode }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem("sidebar_collapsed") === "1"; } catch { return false; }
  });

  useEffect(() => {
    loadTenantSettings();
  }, []);

  useEffect(() => {
    try { localStorage.setItem("sidebar_collapsed", collapsed ? "1" : "0"); } catch { /* ignore */ }
  }, [collapsed]);

  return (
    <QuickPanelProvider sidebarCollapsed={collapsed}>
    <div className="flex min-h-screen bg-[#F1F5F9] dark:bg-gray-900 transition-colors">
      {/* Acionamento dos portais chega sozinho: o aviso tem de existir em
          qualquer tela administrativa, não só na de Portais. */}
      {!adminMode && <PortalDetectionListener />}
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={collapsed}
        onToggle={() => setCollapsed((c) => !c)}
        items={navItems}
        darkSidebar={adminMode}
      />
      <div className="flex flex-1 flex-col min-w-0">
        <Header
          onMenuClick={() => setSidebarOpen(true)}
          sidebarCollapsed={collapsed}
          onToggleSidebar={() => setCollapsed((c) => !c)}
          items={navItems}
          adminMode={adminMode}
        />
        <main
          className="flex-1 p-4 md:p-6"
          data-testid="main-content"
        >
          {children}
        </main>
      </div>
      {/* Apoio rápido: existe em qualquer tela autenticada */}
      <QuickPanelFab />
      <QuickPanelModals />
    </div>
    </QuickPanelProvider>
  );
}
